import * as React from 'react'
import { IServiceEditStep, IServiceEditStepData } from '../../../types/index'
import EntityStepBar from '../../ui/entity/EntityStepBar'
import EntityStepBarItem, { EntityStepState } from '../../ui/entity/EntityStepBarItem'

interface IServiceCreateStepsIndicatorProps {
  steps: IServiceEditStep[]
  currentStep: IServiceEditStepData
}

const ServiceCreateStepsIndicator = (props: IServiceCreateStepsIndicatorProps) => {
  const { steps, currentStep } = props

  const isActive = (index: number): boolean => currentStep.position === index

  return (
    <EntityStepBar>
      {steps.map((it: IServiceEditStep, index: number) => {
        let state = EntityStepState.REGULAR
        if (isActive(index)) {
          state = EntityStepState.CURRENT
        }
        if (it.completed) {
          state = EntityStepState.COMPLETED
        }

        return (
          <EntityStepBarItem index={index} state={state} key={`step-${it.name}`}>
            {it.title}
          </EntityStepBarItem>
        )
      })}
    </EntityStepBar>
  )
}

export default ServiceCreateStepsIndicator



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceCreateStepsIndicator.tsx